import { APIRoute } from '@/modules/utils'

export type Response = never
export type Body = { santevet: boolean }
export type UrlParams = never

export const Route: APIRoute = {
  method: 'POST',
  path: `/acquisition/members/petowners/complete`,
}
